import { render, staticRenderFns } from "./VariantItemOption.vue?vue&type=template&id=1353250e&scoped=true"
import script from "./VariantItemOption.vue?vue&type=script&lang=js"
export * from "./VariantItemOption.vue?vue&type=script&lang=js"
import style0 from "./VariantItemOption.vue?vue&type=style&index=0&id=1353250e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353250e",
  null
  
)

export default component.exports